import { QueryParam } from '../Constants';

function injectBrandCss(href: string) {
  if (document.querySelector(`link[href^="${href}"]`)) {
    return;
  }
  const cssElement = document.createElement('link');
  cssElement.rel = 'stylesheet';
  cssElement.type = 'text/css';
  cssElement.href = href;
  document.head.appendChild(cssElement);
}

export const resolveAppStyles = () => {
  const brand = (new URLSearchParams(location.search).get(QueryParam.Brand) || 'TELIA').toLowerCase();
  // For local development
  if (import.meta.env.DEV) {
    injectBrandCss(`/brandfree-prepaid/css/styles.${brand}.css`);
    return;
  }
  fetch('/brandfree-prepaid/static/manifest.json')
    .then((res) => res.json())
    .then((manifest) => {
      const cssFile = manifest[`${brand}-styles.css`];
      if (cssFile) {
        injectBrandCss(cssFile);
      }
    })
    .catch((err) => console.error(err));
};
